import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminNavBar from "../../NavBar/AdminNavBar";
import style from './UpdatePayroll.module.css'
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function UpdatePayroll() {
    const { employeeId } = useParams();
    const [formData, setFormData] = useState({
        baseSalary: "",
        bonus: "",
        allowances: "",
        deductions: "",
        grossSalary: "",
        netSalary: "",
        notes: "",
        paymentMethod: "Bank Transfer",
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");

    // Fetch payroll details when component mounts
    useEffect(() => {
        const fetchPayroll = async () => {
            try {
                const res = await fetch(`${apiUrl}/payroll/${employeeId}`,
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        }
                    }
                );
                const data = await res.json();

                if (res.ok) {
                    setFormData({
                        baseSalary: data.payroll.baseSalary || "",
                        bonus: data.payroll.bonus || "",
                        allowances: data.payroll.allowances || "",
                        deductions: data.payroll.deductions || "",
                        grossSalary: data.payroll.grossSalary || "",
                        netSalary: data.payroll.netSalary || "",
                        notes: data.payroll.notes || "",
                        paymentMethod: data.payroll.paymentMethod || "Bank Transfer",
                    });
                } else {
                    setError(data.message);
                }
            } catch (err) {
                setError("Failed to fetch payroll");
            } finally {
                setLoading(false);
            }
        };

        fetchPayroll();
    }, [apiUrl, employeeId, token]);

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle update
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiUrl}/payroll/update/${employeeId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
            });

            const data = await res.json();

            if (res.ok) {
                alert("Payroll updated successfully!");
                navigate(`/admin-dashboard/${employeeId}/all-payrolls`);
            } else {
                setError(data.message);
            }
        } catch (err) {
            setError("Failed to update payroll");
        }
    };

    if (error) return <p className="text-danger">{error}</p>;

    return (
        <>
            <AdminNavBar />
            <div style={{ display: 'none' }}>
                {loading ? <p>yes</p> : <p>no</p>}
            </div>
            <div className="container">
                <div className="row mt-lg-2 mb-0 ">

                    {/* BreadCrumb Linkss */}
                    <div className="col-8 col-lg-5 ">
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}`}
                            name="Dashboard"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}/all-payrolls`}
                            name="All Payroll"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}/payroll/update-payroll/${employeeId}`}
                            name={`Payroll update for ${employeeId}`}
                        />
                    </div>
                </div>

                <div className={style.updatePage}>
                    <div className={style.updateContainer}>
                        <div className="container mt-4">
                            <form onSubmit={handleSubmit} className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">Base Salary</label>
                                    <input
                                        type="number"
                                        name="baseSalary"
                                        value={formData.baseSalary}
                                        onChange={handleChange}
                                        className="form-control" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Bonus</label>
                                    <input
                                        type="number"
                                        name="bonus"
                                        value={formData.bonus}
                                        onChange={handleChange}
                                        className="form-control" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Allowances</label>
                                    <input
                                        type="number"
                                        name="allowances"
                                        value={formData.allowances}
                                        onChange={handleChange}
                                        className="form-control" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Deductions</label>
                                    <input
                                        type="number"
                                        name="deductions"
                                        value={formData.deductions}
                                        onChange={handleChange}
                                        className="form-control" />
                                </div>

                                <div className="col-md-12">
                                    <label className="form-label">Notes</label>
                                    <textarea
                                        name="notes"
                                        value={formData.notes}
                                        onChange={handleChange}
                                        className="form-control" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Payment Method</label>
                                    <select
                                        name="paymentMethod"
                                        value={formData.paymentMethod}
                                        onChange={handleChange}
                                        className="form-select" >
                                        <option>Bank Transfer</option>
                                        <option>Cash</option>
                                        <option>Cheque</option>
                                        <option>UPI</option>
                                    </select>
                                </div>

                                <div className="col-12 pb-4 pt-3 text-center">
                                    <button type="submit" className="btn btn-warning">
                                        Update Payroll
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>

            </div>
        </>
    );
}
